export const webActionTypes = {
    URL_REDIRECTION: 'url_redirection',
    PHONE: 'phone',
};
export const appLinkTypes = {
    CATEGORY: 'category',
    PRODUCT: 'product_id',
    LANDING: 'landing_page',
    BRAND: 'brand',
    DEEPLINK: 'deeplink',
    CTA_CALLBACKS_SHADE: 'cta_shade',
    CTA_CALLBACKS_SIZE: 'cta_size',
};
export const POST_ORDER = 'post_order';
